import { useNavigate } from "react-router-dom";
import { create } from "@/apis/template";
import Router from "@/constants/router";
import { useModal } from "mui-modal-provider";
import { Confirm } from "@/organism/Confirm";
import { ErrorDto } from "@/dto/ErrorDto";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";

/**
 * 도장 등록 Hook
 *
 * @returns {object} 도장 등록 관련 메서드
 *
 * @author Max <sud665@ymjlab.com>
 * @version 1.0
 * @since 2025-01-12
 */
export default function useTemplateCreate() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { showModal } = useModal();

  const handleSubmit = async (data: FormData) => {
    const modal = showModal(Confirm, {
      title: "템플릿 등록",
      content: "템플릿을 등록하시겠습니까?",
      onOk: async () => {
        modal.destroy();
        try {
          setIsLoading(true);
          const result = await create(data);
          if (result) {
            enqueueSnackbar("템플릿 등록이 완료되었습니다.", {
              variant: "success",
            });
            navigate(Router.Template);
          }
        } catch (error) {
          const e = error as ErrorDto;
          enqueueSnackbar(
            e.details?.errorMessage || "템플릿 등록에 실패했습니다.",
            {
              variant: "error",
            }
          );
        } finally {
          setIsLoading(false);
        }
      },
      onCancel: () => {
        modal.destroy();
      },
    });
  };

  return {
    handleSubmit,
    isLoading,
  };
}
